/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import BrandIcon from './BrandIcon';
import Button from '../elements/Button';

export default function Footer() {
  return (
    <div className="bg-gray-50 border-t border-gray-200 pb-6">
      <div className="container flex-col mx-auto ">
      <div className="flex flex-wrap justify-between mt-8">
  {/* Column 1: Logo + Caption */}
  <div className="w-full sm:w-1/3 px-4 mb-6 sm:mb-0 text-left">
    <BrandIcon />
    <p className="text-lg font-light whitespace-nowrap sm:whitespace-normal">
      Growing Your Business Is Our Calling
    </p>
  </div>

  {/* Column 2: Office Info */}
  <div className="w-full sm:w-1/3 px-4 mb-6 sm:mb-0 text-left">
    <h1 className="text-lg text-theme-blue pt-4 pb-2">Office</h1>
    <p className="text-lg font-light">Phone: 
      <a href="tel:+61470458200" className="hover:underline"> +61 470 458 200</a>
    </p>
    <p className="text-lg font-light">Email: 
      <a href="mailto:Info@mscontractors.com.au" className="hover:underline"> Info@mscontractors.com.au</a>
    </p>
    <p className="text-lg font-light">Office: 
       1 Woko Walk, Wollert, VIC 3750
    </p>
  </div>

  {/* Column 3: Social Links */}
  <div className="w-full sm:w-1/3 px-4 text-left">
    <h1 className="text-lg text-theme-blue pt-4 pb-2">Social</h1>
    <p><Button
      href="https://www.instagram.com"
      type="link"
      target="_blank"
      className="text-lg font-light hover:underline"
      isExternal
    >
      Instagram
    </Button></p>
    <p><Button
      href="https://www.linkedin.com"
      type="link"
      target="_blank"
      className="text-lg font-light hover:underline"
      isExternal
    >
      LinkedIn
    </Button></p>
  </div>
</div>

        <div className="flex-col text-center mt-7">
          <p className="text-lg font-light">
            Copyright 2021 - All rights reserved - MS Contractors Pty Ltd
          </p>
          {/* <div className="flex-row">
            <p className="inline-block text-lg font-light">
              Made with &#x2764; by&nbsp;
            </p>
            <Button href="https://github.com/racmathafidz" type="link" target="_blank" className="text-lg text-theme-purple font-light" isExternal>
              Racmat Hafidz Fadli
            </Button>
          </div> */}
        </div>
      </div>
    </div>
  );
}
